import type { Action } from 'redux-actions';
import type { SagaIterator } from 'redux-saga';
import { deselectAll, labelAsPayload } from '../actions';
import { call, put, select } from 'redux-saga/effects';
import { requestPuppy } from '@wix/da-http-client';
import { getGrusername } from '../selectors';
import { ALL_FOLDER_ID, SCRAPS_FOLDER_ID } from '@wix/da-url';
import { PapiRequestDaSharedGallectionFoldersSetDeviationsAttr } from '@wix/da-papi-types';

export default function* (action: Action<labelAsPayload>): SagaIterator {
  const { gallection, deviationIds, attribute, value } = action.payload;
  const { folderId } = gallection || {};

  const username: ReturnType<typeof getGrusername> = yield select(
    getGrusername
  );

  const params: PapiRequestDaSharedGallectionFoldersSetDeviationsAttr = {
    username,
    type: 'gallery',
    folderid:
      folderId && ![ALL_FOLDER_ID, SCRAPS_FOLDER_ID].includes(folderId)
        ? folderId
        : undefined,
    all_folder: folderId === ALL_FOLDER_ID,
    scraps_folder: folderId === SCRAPS_FOLDER_ID,
    deviationids: deviationIds,
    attr_name: attribute,
    attr_value: value,
  };

  yield call(
    requestPuppy,
    {
      method: 'post',
      url: 'gallection/folders/set_deviations_attr',
      data: params,
    },
    () => ({ success: true })
  );

  yield put(deselectAll());
}
